import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { ACTIONS, EVENTO, GridDataSource, ICONS, LoaderService, NotificationService, TOOLTIPS } from 'src/app/shared/session';
import { ParametroAutonomiaService } from '../shared/parametro-autonomia.service';

@Component({
  selector: 'app-parametro-autonomia-list',
  templateUrl: './parametro-autonomia-list.component.html',
})
export class ParametroAutonomiaListComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() titlePage: string;
  @Input() data: any;

  displayedColumns: string[] = ['ID', 'Nombre'];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;

  constructor(private loaderService: LoaderService,
    private parametroAutonomiaService: ParametroAutonomiaService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.msgErrorGet = 'Error al listar los parametros de autonomia';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
  }

  handleRowClick(row: any, event: any) {
    if (event.srcElement.cellIndex) {
      if (event.srcElement.cellIndex != 0) {
        this.selectedRowIndex = row.id;
        this.data.parametroAutonomia = { id: this.selectedRowIndex };
        this.changeEvent({ evento: EVENTO.consultar, data: this.data });
      }
    }
  }

  searchEmit(data: any) {
    this.buscarParametroAutonomia(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  buscarParametroAutonomia(filtro: string) {
    this.listarParametroAutonomia(filtro);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  listarParametroAutonomia(filtro: string): void {
    this.loaderService.show();
    this.parametroAutonomiaService.listarParametroAutonomia(filtro)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}
